import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const productCardCarousels = (
  swiperSelector,
  slidesPerViewDesktop,
  slidesPerViewMobile,
  spaceBetween,
  nextEl,
  prevEl,
  scrollbarEl = null,
  isMobileCarouselDisabled = null,
) => {
  return new Swiper(swiperSelector, {
    slidesPerView: slidesPerViewMobile,
    spaceBetween: spaceBetween,
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl,
    },
    ...(scrollbarEl && {
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
        hide: false,
      },
    }),
    breakpoints: {
      375: {
        allowTouchMove: !isMobileCarouselDisabled ?? true,
        scrollbar: !isMobileCarouselDisabled ?? true,
      },
      768: {
        allowTouchMove: true,
        slidesPerView: slidesPerViewDesktop,
      },
    },
  });
};

export { productCardCarousels };
